import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, ChevronDownIcon } from 'lucide-react';
export function StyleTab() {
  const [styleMode, setStyleMode] = useState<'pivot' | 'spans' | 'endgun'>('pivot');
  const [fillColor, setFillColor] = useState('#ffffff');
  const [fontSize, setFontSize] = useState('13');
  const [fontStyle, setFontStyle] = useState({
    italic: false,
    bold: false
  });
  const [fontHeight, setFontHeight] = useState('1.0');
  const [lineColor, setLineColor] = useState('#0000ff');
  const [lineWidth, setLineWidth] = useState('3.2');
  return <div className="space-y-6" data-id="element-269">
      {/* Style Mode Selection - 3 Options */}
      <div data-id="element-270">
        <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-271">
          Select element to edit:
        </label>
        <div className="grid grid-cols-3 gap-2 bg-gray-100 p-1 rounded-lg" data-id="element-272">
          <button onClick={() => setStyleMode('pivot')} className={`px-3 py-2.5 rounded-md text-sm font-medium transition-all ${styleMode === 'pivot' ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-273">
            Pivot
          </button>
          <button onClick={() => setStyleMode('spans')} className={`px-3 py-2.5 rounded-md text-sm font-medium transition-all ${styleMode === 'spans' ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-274">
            Spans
          </button>
          <button onClick={() => setStyleMode('endgun')} className={`px-3 py-2.5 rounded-md text-sm font-medium transition-all ${styleMode === 'endgun' ? 'bg-white text-blue-600 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-275">
            End Gun
          </button>
        </div>
      </div>
      {/* Style Configuration */}
      <div className="space-y-4" data-id="element-276">
        {/* Fill Color */}
        <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-277">
          <label className="block text-sm font-semibold text-gray-700 mb-3" data-id="element-278">
            Fill Color
          </label>
          <div className="flex items-center gap-3" data-id="element-279">
            <input type="color" value={fillColor} onChange={e => setFillColor(e.target.value)} className="w-12 h-12 rounded-lg cursor-pointer border-2 border-gray-300" data-id="element-280" />
            <div className="flex-1" data-id="element-281">
              <input type="text" value={fillColor} onChange={e => setFillColor(e.target.value)} className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-282" />
            </div>
            <select className="px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-283">
              <option data-id="element-284">Solid</option>
              <option data-id="element-285">Pattern</option>
              <option data-id="element-286">Gradient</option>
            </select>
          </div>
        </div>
        {/* Line Style */}
        <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-287">
          <label className="block text-sm font-semibold text-gray-700 mb-3" data-id="element-288">
            Line Style
          </label>
          <div className="space-y-3" data-id="element-289">
            <div className="flex items-center gap-3" data-id="element-290">
              <input type="color" value={lineColor} onChange={e => setLineColor(e.target.value)} className="w-12 h-12 rounded-lg cursor-pointer border-2 border-gray-300" data-id="element-291" />
              <div className="flex-1" data-id="element-292">
                <input type="text" value={lineColor} onChange={e => setLineColor(e.target.value)} className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-293" />
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-294">
              <select className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-295">
                <option data-id="element-296">Solid</option>
                <option data-id="element-297">Dashed</option>
                <option data-id="element-298">Dotted</option>
              </select>
              <div className="flex items-center gap-2" data-id="element-299">
                <span className="text-sm text-gray-600" data-id="element-300">Width:</span>
                <input type="number" value={lineWidth} onChange={e => setLineWidth(e.target.value)} step="0.1" className="w-20 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-301" />
                <span className="text-sm text-gray-600" data-id="element-302">px</span>
              </div>
            </div>
          </div>
        </div>
        {/* Text Style */}
        <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-303">
          <label className="block text-sm font-semibold text-gray-700 mb-3" data-id="element-304">
            Text Style
          </label>
          <div className="space-y-3" data-id="element-305">
            {/* Font Family and Size */}
            <div className="flex items-center gap-3" data-id="element-306">
              <select className="flex-1 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-307">
                <option data-id="element-308">Arial</option>
                <option data-id="element-309">Helvetica</option>
                <option data-id="element-310">Times New Roman</option>
                <option data-id="element-311">Verdana</option>
              </select>
              <div className="flex items-center gap-2" data-id="element-312">
                <input type="number" value={fontSize} onChange={e => setFontSize(e.target.value)} className="w-20 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-313" />
                <span className="text-sm text-gray-600" data-id="element-314">px</span>
              </div>
            </div>
            {/* Font Style Buttons */}
            <div className="flex items-center gap-4" data-id="element-315">
              <div className="flex items-center gap-2" data-id="element-316">
                <span className="text-sm text-gray-600" data-id="element-317">Style:</span>
                <button onClick={() => setFontStyle({
                ...fontStyle,
                italic: !fontStyle.italic
              })} className={`w-10 h-10 flex items-center justify-center rounded-lg border-2 transition-all ${fontStyle.italic ? 'bg-blue-100 border-blue-500 text-blue-600' : 'border-gray-300 text-gray-600 hover:bg-gray-50'}`} data-id="element-318">
                  <span className="italic font-serif text-lg" data-id="element-319">I</span>
                </button>
                <button onClick={() => setFontStyle({
                ...fontStyle,
                bold: !fontStyle.bold
              })} className={`w-10 h-10 flex items-center justify-center rounded-lg border-2 transition-all ${fontStyle.bold ? 'bg-blue-100 border-blue-500 text-blue-600' : 'border-gray-300 text-gray-600 hover:bg-gray-50'}`} data-id="element-320">
                  <span className="font-bold text-lg" data-id="element-321">B</span>
                </button>
              </div>
              <div className="flex items-center gap-2" data-id="element-322">
                <span className="text-sm text-gray-600" data-id="element-323">Height:</span>
                <input type="number" value={fontHeight} onChange={e => setFontHeight(e.target.value)} step="0.1" className="w-20 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-324" />
              </div>
            </div>
            {/* Text Position */}
            <div className="flex items-center gap-2" data-id="element-325">
              <span className="text-sm text-gray-600" data-id="element-326">Position:</span>
              <div className="flex gap-1" data-id="element-327">
                <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-328">
                  <ChevronLeftIcon className="w-5 h-5" data-id="element-329" />
                </button>
                <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-330">
                  <ChevronRightIcon className="w-5 h-5" data-id="element-331" />
                </button>
                <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-332">
                  <ChevronUpIcon className="w-5 h-5" data-id="element-333" />
                </button>
                <button className="w-10 h-10 flex items-center justify-center rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors" data-id="element-334">
                  <ChevronDownIcon className="w-5 h-5" data-id="element-335" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Action Buttons */}
      <div className="flex gap-3 pt-2" data-id="element-336">
        <button className="flex-1 px-4 py-2.5 bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 rounded-lg font-medium transition-colors" data-id="element-337">
          Discard changes
        </button>
        <button className="flex-1 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors" data-id="element-338">
          Save changes
        </button>
      </div>
    </div>;
}